import React from 'react';
import { graphql, withApollo } from 'react-apollo';
import {
  Input,
  Tooltip,
  notification,
  Button,
  Modal,
  DatePicker,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import confirmarRecepcion from '../../../graphql/mutations/venta/confirmarRecepcion.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

@graphql(confirmarRecepcion, {
  name: 'confirmarRecepcion',
})
class ConfirmarIngreso extends React.Component {
  onSubmit = e => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.fechaArrivo = values.fechaArrivo.toDate();
        this.confirmarRecepcion(values);
      }
    });
  };

  confirmarRecepcion = valores => {
    this.props
      .confirmarRecepcion({
        variables: {
          _id: this.props.match.params.id,
          fechaArrivo: valores.fechaArrivo,
          observacion: valores.observacion,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Confirmacion guardada con exito',
          description: 'Se ha registrado los nuevos datos del envio',
        });

        this.props.history.push('/');
      })
      .catch(err => {
        console.log('Error en la confirmacion de la recepcion');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la recepción',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Datos de recepción</h1>
        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha de recepcion
                <Tooltip title="Seleccione la fecha de que se recibió el envio">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaArrivo', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la fecha del envio',
                },
              ],
            })(
              <DatePicker
                style={{ width: 400 }}
                placeholder="Fecha de recepción"
                format="DD/MM/YYYY"
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Observación
                <Tooltip title="Si lo desea, puede agregar algun comentario del envio">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observacion', {})(
              <TextArea style={{ width: 400 }} rows={4} />
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '25%' }}
            >
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(withApollo(ConfirmarIngreso));
